import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import TaiChiItem from "@/components/subject/TaiChi/TaiChiItem.vue";
export default {
  name: "TaiChiBRender",
  components: {
    TaiChiItem
  },
  props: {
    review: {
      type: Object,
      default: () => {
        return null;
      }
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    question: {
      type: Object,
      default: () => {
        return null;
      }
    }
  },
  watch: {
    data() {
      this.init();
    }
  },
  data() {
    return {
      answered: new Set()
    };
  },
  methods: {
    calResult(line, idx) {
      if (!this.reviewMode) {
        return 0;
      }
      if (!this.review) {
        return 2;
      }
      if (this.review.result) {
        return 1;
      }
      let nIdx = line * 13 + idx + 1;
      if (this.question.rightAnswerPos.includes(nIdx)) {
        if (this.question.flags[line][idx] == 1) {
          // 有星星 相同选右边
          return this.review.answer.split(',').includes(String(-1 * nIdx)) ? 1 : 2;
        } else {
          // 没星星 相同选左边
          return this.review.answer.split(',').includes(String(nIdx)) ? 1 : 2;
        }
      } else {
        if (this.question.flags[line][idx] == 1) {
          // 有星星 不相同选左边
          return this.review.answer.split(',').includes(String(nIdx)) ? 1 : 2;
        } else {
          // 没星星 不相同选右边
          return this.review.answer.split(',').includes(String(-1 * nIdx)) ? 1 : 2;
        }
      }
    },
    calIdx(line, idx) {
      let nIdx = line * 13 + idx + 1;
      let rotate = this.question.rotate[line][idx];
      let flag = this.question.flags[line][idx];
      let isRight = this.question.rightAnswerPos.includes(nIdx);
      if (flag > 0) {
        //规定☆为特殊图形，有☆则可旋转，相同点右边，不相同点左边；
        return isRight ? nIdx * -1 : nIdx;
      } else {
        //没有☆则后面图形不可旋转，相同点左边，不相同点右边
        if (rotate > 0) {
          return isRight ? nIdx * -1 : nIdx;
        } else {
          return isRight ? nIdx : nIdx * -1;
        }
      }
    },
    getChooseOf(answer, idx) {
      if (!answer) {
        return 0;
      }
      return answer.split(',').includes(idx.toString()) ? 1 : answer.split(',').includes((idx * -1).toString()) ? 2 : 0;
    },
    onAnswerChoosed(v) {
      if (this.answered.has(v)) this.answered.delete(v);
      if (this.answered.has(-1 * v)) this.answered.delete(-1 * v);
      this.answered.add(v);
      this.$emit('answer', this.answered.size > 0 ? [...this.answered].join(',') : null);
    },
    clearChoose(v) {
      this.answered.delete(v);
      this.$emit('answer', this.answered.size > 0 ? [...this.answered].join(',') : null);
    },
    init() {}
  },
  mounted() {
    this.init();
  }
};